module.exports = __webpack_public_path__ + "static/media/bark.36b4db04.png";